import React from "react";
import './CenteredDiv.css';
import FullQuiz from "./FullQuiz";

export default function Quiz() {
    return (
        <div className="sage-container">
            <FullQuiz/>
        </div>
    )
}